let themeUtils;

export default themeUtils = {
  breakpoints: {
    small: 770,
    medium: 1080,
    large: 1280
  },

  extend(dest, ...objs) {
    for (let i = 0; i < objs.length; i++) {
      const obj = objs[i];
      for (let k in obj) { const v = obj[k]; dest[k] = v; }
    }
    return dest;
  },

  windowWidth() {
    return window.innerWidth;
  },

  isLessThanMedium() {
    return this.windowWidth() < this.breakpoints.small;
  },

  isLessThanLarge() {
    return this.windowWidth() < this.breakpoints.medium;
  },

  isSmall() {
    return this.windowWidth() < this.breakpoints.small;
  },

  isMedium() {
    return (this.windowWidth() >= this.breakpoints.small)
      && (this.windowWidth() < this.breakpoints.medium);
  },

  isLarge() {
    return this.windowWidth() >= this.breakpoints.medium;
  },

  debounce(func, wait, immediate) {
    let timeout = null;
    return function() {
      const context = this;
      const args = arguments;

      const later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };

      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  },

  unique(array) {
    let key;
    let asc;
    let end;
    const output = {};
    for (key = 0, end = array.length, asc = (end >= 0);
      asc ? key < end : key > end;
      asc ? key++ : key--) {
      output[array[key]] = array[key];
    }
    return (() => {
      const result = [];
      for (key in output) {
        const value = output[key];
        result.push(value);
      }
      return result;
    })();
  },

  inViewport(el, direction) {
    let viewportHeight;
    let viewportWidth;
    if (direction == null) { direction = 'both'; }

    const rect = el.getBoundingClientRect();
    const style = el.currentStyle || window.getComputedStyle(el);
    const marginRight = parseInt(style.marginRight) || 0;
    const marginLeft = parseInt(style.marginLeft) || 0;

    if (document.documentElement.clientWidth < window.innerWidth) {
      viewportWidth = document.documentElement.clientWidth;
    } else {
      viewportWidth = window.innerWidth;
    }

    if (document.documentElement.clientHeight < window.innerHeight) {
      viewportHeight = document.documentElement.clientHeight;
    } else {
      viewportHeight = window.innerHeight;
    }

    const inViewportH = ((rect.right - marginRight) >= 0)
      && ((rect.left - marginLeft) <= viewportWidth);
    const inViewportV = (rect.bottom >= 0) && (rect.top <= viewportHeight);

    switch (direction) {
      case 'horizontal': return inViewportH;
      case 'vertical': return inViewportV;
      case 'both': return inViewportV && inViewportH;
    }
  },

  /*
        Resize Flickity slider to tallest cell in viewport
        */
  flickityResize(flickity) {
    const { viewport } = flickity;
    const heights = [];

    for (let i = 0; i < flickity.cells.length; i++) {
      const cell = flickity.cells[i];
      if (this.inViewport(cell.element, 'horizontal')) {
        heights.push(cell.element.getBoundingClientRect().height);
      }
    }

    const height = Math.max.apply(null, heights);

    viewport.style.height = `${height}px`;
  },
};
